export class TypographReplacer {
  openQuotesCount = 0
  previousSymbol = ''

  getTextVal = (node: Node, resStr: string): string => {
    if (node.nodeName.match(/^(P|PRE|LI)$/)) {
      this.openQuotesCount = 0
      this.previousSymbol = ''
    }
    // не делаем автозамену кавычек внутри автора фото и описания фото, т.к. в них могут использоваться прямые ссылки
    // также не делаем автозамену внутри врезки
    if (node?.className && node?.className?.match(/^(image-author)|(image-description)|(sideBar)$/)) {
      let childNodeText = ''

      if (node.childNodes.length > 1 && node.childNodes[0].nodeName === '#text') {
        childNodeText = node.childNodes[0].textContent || ''
      }

      return resStr + childNodeText
    }
    if (node.nodeName === 'P' && node.parentElement?.getAttribute('href') !== node.textContent) {
      // Собираем весь текст из узла <p>, игнорируя теги
      const rawText = node.textContent

      // Обрабатываем текст
      let newTextStr = this.quotesReplacer(rawText || '')

      newTextStr = this.dashReplacerHook(newTextStr)

      // Заменяем текст узлов без уничтожения их структуры
      this.replaceTextInNode(node, newTextStr)

      if (newTextStr?.length) {
        this.previousSymbol = newTextStr[newTextStr.length - 1] || ''
      }

      // Возвращаем обработанный узел как строку
      return resStr + node.textContent
    }

    let resParts = ''
    node.childNodes.forEach(childNode => {
      resParts += this.getTextVal(childNode, resStr)
    })

    return resStr + resParts
  }

  prepositions: string[] = [
    'в',
    'без',
    'до',
    'из',
    'к',
    'на',
    'по',
    'о',
    'от',
    'перед',
    'при',
    'через',
    'для',
    'с',
    'у',
    'за',
    'над',
    'об',
    'под',
    'про',

    'и',
    'о',
    'да',
    'ни',
    'тоже',
    'РФ'
  ]

  replaceTextInNode = (node: Node, newText: string): void => {
    let textIndex = 0

    const traverseAndReplace = (currentNode: Node): void => {
      if (currentNode.nodeType === Node.TEXT_NODE) {
        const originalText = currentNode.textContent || ''
        const replaceLength = originalText.length

        // Заменяем текстовый контент узла
        currentNode.textContent = newText.slice(textIndex, textIndex + replaceLength)

        // Обновляем индекс
        textIndex += replaceLength
      } else {
        // Рекурсивно обходим дочерние узлы
        currentNode.childNodes.forEach(child => traverseAndReplace(child))
      }
    }

    traverseAndReplace(node)
  }

  prepositionReplacer = (sourceStr: string): string => {
    let resStr = ''
    if (sourceStr.match(/\s/)) {
      const sourceStrArr = sourceStr.split(/\s/)

      for (let i = 0; i < sourceStrArr.length; i++) {
        if (this.prepositions.includes(sourceStrArr[i].toLocaleLowerCase())) {
          resStr += sourceStrArr[i] + '\u00A0'
        } else {
          resStr += sourceStrArr[i] + ' '
        }
      }
      return resStr
    }
    return sourceStr
  }

  quotesReplacer = (sourceSentence: string): string => {
    let resStr = ''
    // Проверка на соответствие кавычке
    const regExp = /\»|\«|\"|\＂|\„|\“|\‟|\”|\‚|\‘|\‛|\’|\❝|\❞/
    // Если символ не пробельный и не открывающая скобка
    const previousSymbolRegExp = /(?=\S)(?=[^\(])(?=[^\[])(?=[^\{])(?=[^\<])(?=[^\-])/

    if (sourceSentence.length) {
      for (let i = 0; i < sourceSentence.length; i++) {
        if (sourceSentence[i].match(/\s/)) {
          if ((i === 0 && this.previousSymbol.match(regExp)) || (i > 0 && sourceSentence[i - 1].match(regExp))) {
            resStr = resStr.slice(0, -1) + '» '
          } else {
            resStr += sourceSentence[i]
          }
        } else if (sourceSentence[i].match(regExp)) {
          if ((i === 0 && this.previousSymbol.match(regExp)) || (i > 0 && sourceSentence[i - 1].match(regExp))) {
            if ((i === 0 && this.previousSymbol.match(/\«/)) || (i > 0 && resStr[resStr.length - 1].match(/\«/))) {
              resStr = resStr.slice(0, -1) + '««'
            } else {
              resStr = resStr.slice(0, -1) + '»»'
            }
          } else {
            if (
              (i === 0 && this.previousSymbol.match(previousSymbolRegExp)) ||
              (i > 0 && sourceSentence[i - 1].match(previousSymbolRegExp))
            ) {
              resStr = resStr + '»'
            } else {
              resStr += '«'
            }
          }
        } else {
          resStr += sourceSentence[i]
        }
      }
    }

    let sentence = ''

    if (resStr.length) {
      for (let index = 0; index < resStr.length; index++) {
        if (resStr[index] === '«') {
          this.openQuotesCount++

          sentence += this.openQuotesCount > 1 ? '„' : '«'
        } else if (resStr[index] === '»') {
          sentence += this.openQuotesCount > 1 ? '“' : '»'
          this.openQuotesCount--
        } else {
          sentence += resStr[index]
        }
      }
    }

    return sentence
  }

  dashReplacerHook = (sourceStr: string): string => {
    let sourceSentence = sourceStr
    sourceSentence = sourceSentence.replace(
      /[\s][\-|\—|\–|\‒|\⸻|\⸺|\〜|\┅|\〰|\⹃|\╍|\╌|\⫘|\┉|\┈|\⑈|\╏|\┄|\⥫|\⥬|\⥭|\⩝|\⥪|\⫦\‐|\‑|\﹣|\⁃|\-|\᠆|\⊝|\֊|\⸗|\⸚|\⹀|\゠][\s]/g,
      ' — '
    )
    return sourceSentence
  }

  runTypograph = (sourceObj: Document): Document => {
    this.getTextVal(sourceObj, '')

    return sourceObj
  }

  runTypographForString = (sourceObj: string): string => {
    let resStr = this.quotesReplacer(sourceObj)
    resStr = this.dashReplacerHook(resStr)
    resStr = this.prepositionReplacer(resStr)

    return resStr
  }
}
